import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import NumpadInput from 'components/NumpadInput/NumpadInput'
import './style.css'
import { showMessage } from 'features/MessageBox/duck'
import { useDispatch } from 'react-redux'

const InboundDeliveryRow = ({ row, disabled, onChange, deleteRow, index }) => {

	const dispatch = useDispatch()
	const totalAllocatedQuantity = row.quantities.reduce((sum, alloc) => sum + (Number(alloc.quantityDelivered) || 0), 0)
	const remaining = row.quantityExpected - totalAllocatedQuantity

	const handleOnChangeRowProps = (index, name, value) => {
		onChange(index, name, value)
	}

	const handleOnChange = (allocIndex, name, value) => {
		if (name === 'quantityDelivered') {
			if (value === '0') {
				value = ''
			}

			if (value !== '') {
				const otherAllocated = row.quantities.reduce((sum, alloc, i) =>
					i !== allocIndex ? sum + (Number(alloc.quantityDelivered) || 0) : sum, 0)
				const maxAllowed = row.quantityExpected - otherAllocated
				if (Number(value) > maxAllowed) {
					dispatch(showMessage('Error', 'Quantity delivered cannot be more than the remaining expected quantity'))
					return
				}
			}
		}

		const updatedQuantities = row.quantities.map((alloc, i) =>
			i === allocIndex ? { ...alloc, [name]: value } : alloc
		)

		onChange(index, 'quantities', updatedQuantities)
	}

	const addNewAllocationRow = () => {
		if (remaining > 0) {
			const newAllocation = {
				id: `${row.quantities[0].id}-${row.quantities.length}`,
				quantityDelivered: remaining,
				stockLocation: ''
			}

			onChange(index, 'quantities', [...row.quantities, newAllocation])
		}
	}

	return (
		<div className="inboundDeliveryRow">
			<span className="articleText">{row.articleText}</span>
			<div className="deliveryRow header">
				<span>{'Quantity ordered'}</span>
				<span>{'Quantity expected'}</span>
			</div>
			<div className="deliveryRow">
				<span>{row.quantityOrdered}</span>
				<span>{row.quantityExpected}</span>
			</div>

			{row.quantities.map((alloc, indx) => (
				<div key={alloc.id} className="allocationRow">
					<div className="btnLabels row">
						<span>{'Quantity delivered'}</span>
						<span>{'Stock location'}</span>
					</div>
					<div className="inputs">
						<div className="input">
							<NumpadInput
								name="quantityDelivered"
								disabled={disabled}
								value={alloc.quantityDelivered}
								onChange={(name, value) => handleOnChange(indx, name, value)}
							/>
						</div>
						<div className="input">
							<NumpadInput
								name="stockLocation"
								disabled={disabled}
								value={alloc.stockLocation}
								onChange={(name, value) => handleOnChange(indx, name, value)}
							/>
						</div>
					</div>

					{indx === row.quantities.length - 1 && alloc.quantityDelivered < row.quantityExpected && totalAllocatedQuantity < row.quantityExpected && (
						<div className="splitAllocation row">
							<Button
								className='splitAllocationButton'
								variant="primary"
								onClick={addNewAllocationRow}
							>
								Add allocation
							</Button>
						</div>
					)}

				</div>
			))}
			<div className="btnLabels row">
				<span>{'Dot year'}</span>
				<span>{'Weight'}</span>
			</div>
			<div className="inputs">
				<div className="input">
					<NumpadInput
						name="dotYear"
						disabled={disabled}
						value={row.dotYear || ''}
						onChange={(name, value) => handleOnChangeRowProps(index, name, value)}
					></NumpadInput>
				</div>
				<div className="input">
					<NumpadInput
						name="weight"
						disabled={disabled}
						value={row.weight || ''}
						onChange={(name, value) => handleOnChangeRowProps(index, name, value)}
					></NumpadInput>
				</div>
			</div>

			<div className="deleteInboundRow row">
				<Button
					className='deleteInboundRowButton'
					variant="danger"
					size="xxl"
					onClick={() => deleteRow(row.id)}
				>
					Delete row
				</Button>
			</div>

			{row.brokenRules.map((i) => (
				<div key={i.description} className="broken-rule">
					<span>{i.property} : </span>
					<span>{i.description}</span>
				</div>
			))}
		</div>
	)
}

InboundDeliveryRow.propTypes = {
	row: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	deleteRow: PropTypes.func.isRequired,
	index: PropTypes.number.isRequired,
}

export default InboundDeliveryRow
